<script>
import ChanelDonut from "@/components/chanelDonut";

export default {
    components: { ChanelDonut},

      props: {
        deliveredByCity: {
            type: Object,
            default: () => null
        },

    },
 

};
</script>

<template>
  <div class="card " style="border:1px solid #ddd;">
    <div class="card-body ">

        <h4 class="text-dark text-uppercase font-weight-bold">{{$t('campaign.card.distributedByCity')}}</h4>


        <ChanelDonut v-if="deliveredByCity " :data="deliveredByCity.totalQuantity" :labels="deliveredByCity.cityName" :title="$t('campaign.card.distributedByCity')"   />
    </div>
  </div>
</template>